import { DEBUG_ADMINS, PREVIEW_FEATURE_ADMINS } from "../config";

function normalizeAccountId(value) {
  return String(value || "").trim().toLowerCase();
}

export function isConfiguredAdmin(accountId, admins = DEBUG_ADMINS) {
  const normalizedAccountId = normalizeAccountId(accountId);
  if (!normalizedAccountId) return false;

  return admins.some((adminAccountId) =>
    normalizeAccountId(adminAccountId) === normalizedAccountId
  );
}

export function isPreviewFeatureAdmin(accountId, admins = PREVIEW_FEATURE_ADMINS) {
  return isConfiguredAdmin(accountId, admins);
}

export function hasAdminAccess(accountId, user, isBackendAdmin) {
  if (isConfiguredAdmin(accountId)) return true;

  return Boolean(
    isBackendAdmin &&
    normalizeAccountId(user?.near_wallet) === normalizeAccountId(accountId)
  );
}

export function canAccessEconomics(accountId, user, isBackendAdmin) {
  const normalizedAccountId = normalizeAccountId(accountId);
  if (!normalizedAccountId || !isPreviewFeatureAdmin(normalizedAccountId)) return false;
  return Boolean(
    isBackendAdmin &&
    normalizeAccountId(user?.near_wallet) === normalizedAccountId
  );
}
